import { AiOutlineCheck } from 'react-icons/ai';
import { OrderIcon } from '../../../../../../assets/svg/order';
import { Card } from '../../../../../../components/card/card';
import { IconButton } from '../../../../../../components/icon-button/icon-button';
import { Loader } from '../../../../../../components/loader/loader';
import { Slider } from '../../../../../../components/slider/slider';
import { SortableItem } from '../../../../../../features/sorter/sortable-item';
import { Sorter } from '../../../../../../features/sorter/sorter';
import { isMobile } from '../../../../../../helpers/devices';
import { useManagerStore } from '../../../../../../store/use-manager-store';
import s from './menu-iiko-slider.module.css';
import { useMenuIikoSlider } from './use-menu-iiko-slider';

export const MenuIikoSlider = () => {
  const {
    t,
    getLocale,
    menuList,
    menuId,
    isRenderSlider,
    addQueryParams,
    isLoading,
    setIikoMenuListOrder,
  } = useMenuIikoSlider();
  const { hasAccess } = useManagerStore();
  const isNotAllowed = !hasAccess('menu', ['write']);

  return (
    <div className={s.feature}>
      {isLoading && <Loader />}
      {isRenderSlider && (
        <Card className={s.container}>
          <h3>{t('Меню')}</h3>

          <div className={s.row}>
            <Sorter
              itemIds={menuList.map((item) => item.id)}
              onSort={(e) => setIikoMenuListOrder(e.map(String))}
              axis="x"
              isDisabled={isNotAllowed}
            >
              <Slider
                desktopSwipe={false}
                perSlide={4}
                count={menuList.length}
                responsive={{
                  1260: {
                    perSlide: 3,
                  },
                  840: {
                    perSlide: 2,
                  },
                  420: {
                    perSlide: 1,
                  },
                }}
              >
                {menuList.map((item, index) => {
                  const imgSrc = item.images?.main?.normal || item.images?.main?.thumbnail;
                  const isSelected = menuId === String(item.id);
                  const menuName = getLocale(item.name);
                  const imgFallback = getLocale(item.name)
                    .split(' ')
                    .filter(Boolean)
                    .map((word) => word[0].toUpperCase())
                    .join('');

                  return (
                    <SortableItem
                      key={item.id}
                      isDisabled={isNotAllowed}
                      sortableArgs={{
                        id: item.id,
                        data: {
                          index,
                        },
                      }}
                      withSortIcon={false}
                    >
                      <div key={item.id} onClick={() => addQueryParams({ menuId: item.id })}>
                        <div className={s['menu-item']}>
                          <div className={s['img-wrapper']}>
                            {imgSrc ? (
                              <img src={imgSrc} className={s.img} />
                            ) : (
                              <span className={s.fallback}>{imgFallback}</span>
                            )}
                            {isSelected && (
                              <div className={s['icon-wrapper']}>
                                <AiOutlineCheck className={s.icon} />
                              </div>
                            )}
                            {!isMobile() && !isNotAllowed && (
                              <IconButton variant="ghost" className={s.order} size="sm">
                                <OrderIcon />
                              </IconButton>
                            )}
                          </div>

                          <div className={s.bottom}>
                            <span className={s.name}>{menuName}</span>
                          </div>
                        </div>
                      </div>
                    </SortableItem>
                  );
                })}
              </Slider>
            </Sorter>
          </div>
        </Card>
      )}
    </div>
  );
};
